/* eslint-disable react-hooks/rules-of-hooks */
import useGetPayment from '@/hooks/api/useGetPayment';
import { PaymentInfoState } from '@/states/paymentInfoState';
import { getPaymentTypeText } from '@/utils/common';

import { Constants } from '@/utils/constants';
import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';

type Props = {
  // eslint-disable-next-line react/require-default-props
  editPage?: boolean;
};

/**
 * お支払情報の表のコンポーネント
 * 現在の支払い方法ごとに必要な列だけを出し分け、共通の参照テーブルとして利用する。
 * @returns お支払情報の表のコンポーネント
 */
const PaymentTable = ({ editPage = false }: Props) => {
  // お支払い情報取得API
  const { execute: callAPIGetPayment } = useGetPayment();
  const paymentInfo = useRecoilValue(PaymentInfoState);

  useEffect((): void => {
    // 表示専用コンポーネントでも最新の支払情報を自前で取得しておく。
    callAPIGetPayment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='m-table'>
      <table>
        <colgroup>
          <col width='40%' />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th className='m-table__th'>お支払い方法</th>
            <td className='m-table__td' data-testid='payment_type'>
              {getPaymentTypeText(paymentInfo.payment_type)}
            </td>
          </tr>

          {paymentInfo.payment_type === Constants.PaymentMethod.CREDIT_CARD.code && (
            <tr>
              <th className='m-table__th'>クレジットカード番号</th>
              <td className='m-table__td' data-testid='credit_card_no'>
                {paymentInfo?.credit_card?.credit_card_no}
                {editPage && (
                  <>
                    <br />
                    セキュリティ上の観点から、下4桁のみを表示しています。
                  </>
                )}
              </td>
            </tr>
          )}

          {/* 自動口座振替 */}
          {paymentInfo.payment_type === Constants.PaymentMethod.ACCOUNT_TRANSFER.code && (
            <>
              <tr>
                <th className='m-table__th'>金融機関名</th>
                <td className='m-table__td'>{paymentInfo.koufuri_info?.bank_name}</td>
              </tr>
              <tr>
                <th className='m-table__th'>
                  {paymentInfo.koufuri_info?.jp_bank_flg === '0' && '支店名'}
                  {paymentInfo.koufuri_info?.jp_bank_flg === '1' && '通帳記号'}
                </th>
                <td className='m-table__td'>{paymentInfo.koufuri_info?.branch_name}</td>
              </tr>
              <tr>
                <th className='m-table__th'>口座番号</th>
                <td className='m-table__td'>{paymentInfo.koufuri_info?.ac_hold_no}</td>
              </tr>
            </>
          )}

          {/* 合算請求先の携帯電話番号: NTT */}
          {paymentInfo.payment_type === Constants.PaymentMethod.NTT_TEL.code && (
            <tr>
              <th className='m-table__th'>合算請求先の携帯電話番号</th>
              <td className='m-table__td'>{paymentInfo.ntt_info?.bl_tel}</td>
            </tr>
          )}

          {/* 合算請求先の携帯電話番号: SB */}
          {paymentInfo.payment_type === Constants.PaymentMethod.SB_TEL.code && (
            <tr>
              <th className='m-table__th'>合算請求先の携帯電話番号</th>
              <td className='m-table__td'>{paymentInfo.sb_info?.bl_tel}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PaymentTable;
